import { render, staticRenderFns } from "./PriceCalculation.vue?vue&type=template&id=7c852126&scoped=true&"
import script from "./PriceCalculation.vue?vue&type=script&lang=js&"
export * from "./PriceCalculation.vue?vue&type=script&lang=js&"
import style0 from "./PriceCalculation.vue?vue&type=style&index=0&id=7c852126&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c852126",
  null
  
)

export default component.exports